export default __webpack_public_path__ + "static/media/05AW2JUL66.24ff309d.jpg";